// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { Table } from 'react-bootstrap';
import DollarOutput from '../../utils/DollarOutput';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../infrastructure/utils/common';
import ExpensesMobile from './ExpensesMobile';

class Expenses extends React.Component {
  render() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { expenses } = this.props;

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    if (expenses.length === 0) {
      return 'None';
    }

    if (isMobileResolution()) {
      return <ExpensesMobile expenses={expenses} />;
    }
    return (
      <div className='expense'>
        <Table hover>
          <thead>
            <tr>
              <th>Event</th>
              <th className='currency'>Amount</th>
              <th>Payer</th>
            </tr>
          </thead>
          <tbody>
            {/* TODO: Fix this the next time the file is edited. */}
            {/* eslint-disable-next-line react/prop-types */}
            {expenses.map(expense => (
              <tr key={expense.expenseId}>
                <td>{expense.eventName}</td>
                <td className='currency'>
                  <DollarOutput value={expense.amountPaid} />
                </td>
                <td>{expense.payerName}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default Expenses;
